// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7774a615","453":"a1a0e49a","732":"e91fc14e"}[chunkId] + ".chunk.js";
};